import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

const CORE_VALUES = [
  { title: "Integrity", copy: "We protect trust before pursuing opportunity." },
  { title: "Intentionality", copy: "We do not create merely to add more. We create because something deserves to exist." },
  { title: "Intelligence", copy: "Every decision should be informed, considered and capable of standing up to scrutiny." },
  { title: "Beauty", copy: "Aesthetic excellence is not decoration. It is part of how people experience value." },
  { title: "Courage", copy: "We build beyond inherited limitations and familiar categories." },
  { title: "Long-Term Thinking", copy: "We measure success in years and decades, not moments." },
  { title: "Humanity", copy: "The people touched by our work matter more than the appearance of achievement." },
  { title: "Evolution", copy: "The group will continue to grow without losing the philosophy at its centre." },
];

const VisionValues = () => {
  return (
    <div data-testid="page-vision-values">
      <SEO
        title="Vision & Values"
        description="To build meaningful ventures that unite intelligence, integrity, beauty and human transformation, creating lasting value for clients, communities and the future."
        path="/vision-values"
      />
      <PageHero eyebrow="Vision & Values" heading="Building What the Future Will Remember" />

      <section className="relative page-shell py-14 md:py-20 lg:py-24">
        <div className="grid md:grid-cols-2 gap-14">
          <Reveal>
            <span className="eyebrow block mb-5">Our Mission</span>
            <p className="text-editorial text-justify">
              To build meaningful ventures that unite intelligence, integrity, beauty and human
              transformation, creating lasting value for clients, communities and the future.
            </p>
          </Reveal>
          <Reveal delay={100}>
            <span className="eyebrow block mb-5">Our Vision</span>
            <p className="text-editorial text-justify">
              To grow Gopi Gadhvi Group into an internationally respected ecosystem of businesses,
              intellectual property, creative platforms and strategic investments, each distinct in
              purpose yet united by one enduring standard.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-14 md:py-20 lg:py-24" style={{ background: "var(--gg-midnight-black)" }}>
        <div className="page-shell">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <span className="eyebrow block mb-5">Core Values</span>
            <h2 className="text-h2">What We Hold Ourselves To</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10">
            {CORE_VALUES.map((v, i) => (
              <Reveal key={v.title} delay={i * 40} className="pl-5" style={{ borderLeft: "1px solid var(--gg-fine-border)" }}>
                <p className="eyebrow mb-2" style={{ color: "var(--gg-pearl)" }}>{v.title}</p>
                <p className="text-body">{v.copy}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative page-shell py-14 md:py-20 lg:py-24 text-center">
        <Reveal className="max-w-2xl mx-auto">
          <p className="font-cormorant italic text-h4" style={{ color: "var(--gg-pearl)" }} data-testid="vision-values-closing">
            Different worlds may require different forms. What matters is that each one is built
            with meaning, held to the same standard and allowed to become something enduring.
          </p>
        </Reveal>
      </section>
    </div>
  );
};

export default VisionValues;
